import request from '../../request';
import { artifactApi } from './insightsUrls';

export default class artifactService {
  static async get(src) {
    return request({
      url: artifactApi.get(src),
      method: 'GET',
    });
  }
  static async post(data) {
    return request({
      url: artifactApi.post(),
      method: 'POST',
      data,
      contentType: 'multipart/form-data',
    });
  }
}
